import { render, staticRenderFns } from "./temp-objective.vue?vue&type=template&id=600cfda8&scoped=true"
import script from "./temp-objective.vue?vue&type=script&lang=js"
export * from "./temp-objective.vue?vue&type=script&lang=js"
import style0 from "./temp-objective.vue?vue&type=style&index=0&id=600cfda8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600cfda8",
  null
  
)

export default component.exports